'use strict';

module.exports = document.createElement('div').style;



//////////////////
// WEBPACK FOOTER
// ./~/domkit/builtinStyle.js
// module id = 725
// module chunks = 4